/**
 * HOOK: useMaze
 * Gestisce il labirinto, dots e power pellets
 */

import { useState, useCallback } from 'react'
import { GAME_CONFIG } from '../types/GameConstants'

export function useMaze() {
  const [maze, setMaze] = useState<number[][]>([])
  const [dots, setDots] = useState<Set<string>>(new Set())
  const [powerPellets, setPowerPellets] = useState<Set<string>>(new Set())
  const [totalDots, setTotalDots] = useState(0)

  const initializeMaze = useCallback(() => {
    const newMaze = [
      [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
      [1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1],
      [1,0,1,1,1,1,0,1,1,1,1,1,0,1,1,1,1,0,1,1,0,1,1,1,1,0,1,1,1,1,1,0,1,1,1,1,0,1],
      [1,0,1,1,1,1,0,1,1,1,1,1,0,1,1,1,1,0,1,1,0,1,1,1,1,0,1,1,1,1,1,0,1,1,1,1,0,1],
      [1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1],
      [1,0,1,1,1,1,0,1,1,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,1,1,0,1,1,1,1,0,1],
      [1,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,1],
      [1,1,1,1,1,1,0,1,1,1,1,1,0,1,1,1,1,0,1,1,0,1,1,1,1,0,1,1,1,1,1,0,1,1,1,1,1,1],
      [1,1,1,1,1,1,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,1,1,1,1,1,1],
      [1,1,1,1,1,1,0,1,1,0,1,1,1,2,2,2,2,2,2,2,2,2,2,2,1,1,1,0,1,1,0,1,1,1,1,1,1],
      [1,0,0,0,0,0,0,0,0,0,1,2,2,2,2,2,2,2,2,2,2,2,2,2,2,1,0,0,0,0,0,0,0,0,0,1],
      [1,1,1,1,1,1,0,1,1,0,1,2,2,2,2,2,2,2,2,2,2,2,2,2,2,1,0,1,1,0,1,1,1,1,1,1],
      [1,1,1,1,1,1,0,1,1,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,1,1,0,1,1,1,1,1,1],
      [1,1,1,1,1,1,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,1,1,1,1,1,1],
      [1,1,1,1,1,1,0,1,1,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,1,1,0,1,1,1,1,1,1],
      [1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1],
      [1,0,1,1,1,1,0,1,1,1,1,1,0,1,1,1,1,0,1,1,0,1,1,1,1,0,1,1,1,1,1,0,1,1,1,1,0,1],
      [1,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,1],
      [1,1,1,0,1,1,0,1,1,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,1,1,0,1,1,0,1,1,1],
      [1,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,1],
      [1,0,1,1,1,1,1,1,1,1,1,1,0,1,1,1,1,0,1,1,0,1,1,1,1,0,1,1,1,1,1,1,1,1,1,1,0,1],
      [1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1],
      [1,0,1,1,1,1,0,1,1,1,1,1,0,1,1,1,1,0,1,1,0,1,1,1,1,0,1,1,1,1,1,0,1,1,1,1,0,1],
      [1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1],
      [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
      // RIGHE AGGIUNTIVE PER RIEMPIRE LO SPAZIO
      [1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1],
      [1,0,1,1,1,1,0,1,1,1,1,1,0,1,1,1,1,0,1,1,0,1,1,1,1,0,1,1,1,1,1,0,1,1,1,1,0,1],
      [1,0,0,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,0,0,0,1],
      [1,1,1,0,1,1,0,1,1,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,1,1,0,1,1,0,1,1,1],
      [1,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,0,0,0,1,1,0,0,0,0,0,0,1],
      [1,0,1,1,1,1,1,1,1,1,1,1,0,1,1,1,1,0,1,1,0,1,1,1,1,0,1,1,1,1,1,1,1,1,1,1,0,1],
      [1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1],
      [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]
    ]
    
    // Aggiungi più righe per riempire l'altezza
    while (newMaze.length < 31) {
      newMaze.push(Array(38).fill(1))
    }
    
    setMaze(newMaze)
    
    // Initialize dots and power pellets
    const newDots = new Set<string>()
    const newPowerPellets = new Set<string>()
    
    for (let row = 0; row < newMaze.length; row++) {
      for (let col = 0; col < newMaze[row].length; col++) {
        if (newMaze[row][col] === 0) {
          // POWER PELLETS STRATEGICI - Posizionamento perfezionato
          if ((row === 2 && col === 1) ||   // Angolo alto sinistra
              (row === 2 && col === 36) ||  // Angolo alto destra  
              (row === 22 && col === 1) ||  // Angolo basso sinistra
              (row === 22 && col === 36) || // Angolo basso destra
              (row === 15 && col === 5) ||  // Centro sinistra
              (row === 15 && col === 32) || // Centro destra
              (row === 25 && col === 18) || // Centro basso
              (row === 29 && col === 10) || // Zona finale sinistra
              (row === 29 && col === 27)) { // Zona finale destra
            newPowerPellets.add(`${col},${row}`)
          } else {
            newDots.add(`${col},${row}`)
          }
        }
      }
    }
    
    setDots(newDots)
    setPowerPellets(newPowerPellets)
    setTotalDots(newDots.size + newPowerPellets.size)
  }, [])

  const isValidPosition = useCallback((x: number, y: number): boolean => {
    const col = Math.floor(x / GAME_CONFIG.CELL_SIZE)
    const row = Math.floor(y / GAME_CONFIG.CELL_SIZE)
    
    if (row < 0 || row >= maze.length || col < 0 || col >= maze[0]?.length) {
      return false
    }
    
    return maze[row][col] !== 1
  }, [maze])

  const removeDot = useCallback((dotKey: string) => {
    setDots(prev => {
      const newDots = new Set(prev)
      newDots.delete(dotKey)
      return newDots
    })
  }, [])

  const removePowerPellet = useCallback((pelletKey: string) => {
    setPowerPellets(prev => {
      const newPellets = new Set(prev)
      newPellets.delete(pelletKey)
      return newPellets
    })
  }, [])

  return {
    maze,
    dots,
    powerPellets,
    totalDots,
    initializeMaze,
    isValidPosition,
    removeDot,
    removePowerPellet
  }
}
